import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {constants} from '../constant/constant';
import {HttpClient} from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
  }

  getAllProPackages(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/packages/get/promotions?type=1");
  }

  getallCategorys(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/util/package-category/getActive");
  }
  getallTicket(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/airticket/search",req);
  }

  searchCategorys(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/packages/search",req);
  }

  bookingSave(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/booking/save",req);
  }
  ticketbookingSave(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/booking/ticket/save",req);
  }

  getPackagebyCategory(id): Observable<any>{
    return this.http.get<any>(constants.main_url + "/packages/getByCategory/"+id);
  }

  getallGalry(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/gallery/get/images");
  }

  addReview(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/client-reviews/saveOrEdit",req);
  }

  packageSearch(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/packages/search",req);
  }

  packageSearch2(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/packages/search?size=" + size + "&page=" + page, req);
  }

  getallTrasport(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/transport/getAll");
  }

  getallReviews(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/client-reviews/getAll");
  }


  contact(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/util/customer/inquiry",req);
  }
}
